import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=5787f9a8&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"
import style0 from "./PDF.vue?vue&type=style&index=0&id=5787f9a8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787f9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5787f9a8')) {
      api.createRecord('5787f9a8', component.options)
    } else {
      api.reload('5787f9a8', component.options)
    }
    module.hot.accept("./PDF.vue?vue&type=template&id=5787f9a8&scoped=true", function () {
      api.rerender('5787f9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PDF.vue"
export default component.exports